export const actionLinkActionType = {
  OrganisationInvite: "OrganisationInvite",
  OrganisationInviteExisting: "OrganisationInviteExisting",
  PasswordReset: "PasswordReset",
  EventCreator: "EventCreator",
} as const;

export type ActionLinkActionType =
  (typeof actionLinkActionType)[keyof typeof actionLinkActionType];
